/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { Component, computed, inject, signal, ViewEncapsulation } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SendUpdateRouteService } from '../send-update-route.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { ImageCropperComponent, ImageCroppedEvent, LoadedImage } from 'ngx-image-cropper';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ToolsService } from 'src/app/services/tools.service';
import { SharedModule } from 'src/app/shared/shared.module';
import Swal from 'sweetalert2';
import { catchError, of, throwError } from 'rxjs';
import { DebugService } from 'src/app/services/debug.service';

@Component({
  selector: 'cicerone-update-route-tech-page',
  standalone: true,
  imports: [CommonModule, TranslateModule, ImageCropperComponent, SharedModule],
  templateUrl: './tech-page.component.html',
  styleUrls: ['./tech-page.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class TechPageComponent {
    private debugService = inject(DebugService);
    
    private sendUpdateService = inject(SendUpdateRouteService);
    public translate = inject(TranslateService);
    public tools = inject(ToolsService);
    private navigationService = inject(NavigationService)
    private sanitizer = inject(DomSanitizer)
    public additionalInfo = computed(() => this.sendUpdateService.userData()?.info)
    public imageChangedEvent: Event | null = null;
    public croppedImage: SafeUrl  = '';
    public item = computed(() => this.sendUpdateService.item());
    public name = this.item().name ?? {};
    public savingRoute = signal(false);
    base64Image: any;

    fileChangeEvent(event: Event): void {
        this.imageChangedEvent = event;
    }
    imageCropped(event: ImageCroppedEvent) {
      this.croppedImage = this.sanitizer.bypassSecurityTrustUrl(event.objectUrl);
      this.base64Image = event.base64;
      this.sendUpdateService.item.update(prev => ({...prev, image: event.base64}))
      // event.blob can be used to upload the cropped image
    }
    imageLoaded(image: LoadedImage) {
        // show cropper
    }
    cropperReady() {
        // cropper ready
    }
    loadImageFailed() {
        // show message
    }
    
    goBack() {
      this.navigationService.goBack();
    }

    focusin(evt) {
        evt.stopPropagation();
    }

    insertText(value, lang){
        this.name[lang] = value;
        this.sendUpdateService.item.update(prev => ({...prev, name: this.name}))
    }

    saveRoute(){
        let data = {
            routeId: this.item()?.id,
            routeName: this.name,
            routeImage: this.base64Image && this.base64Image !== '' ? this.base64Image : null,
            isRecommendedRoute: 1
        }

        if(this.sendUpdateService.item()?.id){
            data['id'] = this.sendUpdateService.item()?.id;
            this.savingRoute.set(true);
            this.sendUpdateService.updatedRoute(data)
            .pipe(
                catchError((error) => {
                    this.savingRoute.set(false);
                    Swal.fire({ icon: 'error', title: '', text: this.translate.instant('Ha ocurrido un error al actualizar la ruta') })
                    return throwError(() => new Error('HTTP request failed', { cause: error }));
                }),
            )
            .subscribe(response => {
                this.debugService.debug(response, '[TechPageComponent] Tech Update Route API Response');
                this.savingRoute.set(false);
                Swal.fire({
                    title: '',
                    text: this.translate.instant('Su ruta ha sido actualizada'),
                    icon: 'success',
                    showCancelButton: false,
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'OK',
                    timer: 2500,
                    timerProgressBar: true,
                }).then((result) => {
                    this.goBack()
                })   
            });
            return;
        }

        this.sendUpdateService.saveRoute(data).subscribe(response => {
            this.debugService.debug(response, '[TechPageComponent] Tech Save Route API Response');
            const routeId = response.data?.id;
            if (response.status == 'OK'){
                Swal.fire({
                    title: '',
                    text: this.translate.instant(`Su ruta ha sido guardada`),
                    icon: 'success',
                    showCancelButton: false,
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'OK',
                    timer: 2500,
                    timerProgressBar: true,
                }).then((result) => {
                    this.goBack()                
                })
                return;
            }
            Swal.fire({ icon: 'error', title: '', text: this.translate.instant(`Ha ocurrido un error al guardar la ruta`) })
        });

    }

}
